import type Template from "./light.json";

export type DesignsToken = typeof Template;

export enum DesignsTokenTheme {
  LIGHT = "LIGHT",
  DARK = "DARK",
}

const filenames = {
  LIGHT: "light.json",
  DARK: "dark.json",
};

export async function fetchTheme(
  theme: DesignsTokenTheme,
): Promise<DesignsToken> {
  return JSON.parse(JSON.stringify(await import(`./${filenames[theme]}`)));
}
